/**
 * Persian text normalization for names, addresses, and search (material-standard §3.6).
 */

import { normalizeDigits } from './digits.js';

const ARABIC_YEH = /\u064A/g;
const ARABIC_KAF = /\u0643/g;
const ZWNJ = /\u200c/g;

/** Maps Arabic ي/ك to Persian ی/ک; keeps ZWNJ (نیم‌فاصله). */
export function normalizePersianText(text: string): string {
  return text.replace(ARABIC_YEH, '\u06CC').replace(ARABIC_KAF, '\u06A9');
}

/**
 * Normalizes free text for case-insensitive Persian search: Arabic letters, digits to ASCII, ZWNJ removed,
 * surrounding whitespace trimmed.
 */
export function normalizeSearchText(text: string): string {
  return normalizePersianText(normalizeDigits(text)).replace(ZWNJ, '').trim();
}
